<template>
  <div class="c-lgs-view">
    <div class="c-speech-bubble">
      <div class="c-speech-bubble__inner">
        <h1 class="c-speech-bubble__heading">
          Calculate your
          <span class="c-speech-bubble__heading--yellow">power savings</span>
        </h1>
      </div>
    </div>

    <div class="c-lgs-view_container">
      <div class="c-lgs-view_container__inner">
        <div class="c-view-content-col">
          <div class="c-view-content-col__inner">
            <div
              class="c-lgs-content"
              v-html="LetsGetStarted.LetsGetStartedViewContent"
            ></div>
            <button class="u-calc-button" @click="start">
              <p>Let's get started</p>
              <span></span>
            </button>
          </div>
        </div>
        <div class="c-lgs-view_animation-col c-view-animation-col">
          <div class="c-lgs-view_animation-wrapper">
            <lottie-vue-player
              :src="animationsURL + `logo_money_animation.json`"
              :player-controls="false"
              :loop="true"
              :autoplay="true"
            >
            </lottie-vue-player>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";

export default {
  created() {},
  components: {},
  mounted() {},
  methods: {
    start() {
      this.currentView = "SliderView";
    },
  },
  computed: {
    ...mapFields([
      "viewContent.LetsGetStarted",
      "config.baseUrl",
      "config.currentView",
    ]),
    /**
     * Returns animation url
     *
     * @return string
     * **/
    animationsURL() {
      return this.baseUrl + "/app/animations/";
    },
  },
};
</script>
<style lang="scss">
.c-lgs-view {
  background: rgb(244, 148, 1);
  background: linear-gradient(
    93deg,
    rgba(244, 148, 1, 1) 0%,
    rgba(254, 171, 3, 1) 100%
  );
  min-height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.c-speech-bubble {
  width: 100%;
  background: #000000;
  clip-path: polygon(
    0% 0%,
    100% 0,
    100% 140px,
    75% 140px,
    65% 100%,
    65% 140px,
    0% 140px
  );
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 62px;
  position: relative;
  z-index: 1;

  @media (max-width: 900px) {
    padding-bottom: 50px;
  }

  @media (max-width: 755px) {
    padding-bottom: 40px;
  }

  @media (max-width: 568px) {
    padding-bottom: 30px;
  } 
}

.c-speech-bubble__inner {
}

.c-speech-bubble__heading {
  color: #ffffff;
  font-family: "Nunito" !important;
  font-weight: 800 !important;
  font-size: 60px !important;
  line-height: 82px !important;
  padding: 28px 0;

  &--yellow {
    color: #fdb930;
  }

  @media (max-width: 900px) {
    font-size: 52px !important;
    line-height: 60px !important;
    padding: 50px 0%;
    max-width: none;
  }

  @media (max-width: 755px) {
    font-size: 45px !important;
    line-height: 51px !important;
    padding: 31px 5%;
    max-width: 345px;
  }

  @media (max-width: 568px) {
    font-size: 30px !important;
    line-height: 41px !important;
    padding: 20px 5%;
    max-width: 235px;
  }

}

.c-lgs-content {
  max-width: 355px;
  margin-bottom: 40px;
  padding-top: 90px;

  @media (max-width: 755px) {
    padding-top: 20px;
    max-width: none;
  }
}

.c-lgs-view_container {
  margin: 0 auto;
  margin-left: auto;
  margin-top: -60px;
  padding: 0;
  padding-left: 90px;

  @media (max-width: 755px) {
    padding-left: 0;
  }

  .c-view-content-col {
    display: flex;
    flex-direction: row-reverse;

    @media (max-width: 755px) {
      flex-direction: row;
      padding: 0 5%;
    }
  }

  .c-view-animation-col {
    @media (max-width: 755px) {
      width: 100%;
      margin-top: 50px;
    }
  }
}

.c-lgs-view_container__inner {
  display: flex;
  flex-direction: row;

  @media (max-width: 755px) {
    flex-direction: column-reverse;
  }
}

.c-lgs-view_animation-wrapper {
  max-width: 550px;
  margin: 0 0 0 auto;

  @media (max-width: 755px) {
    width: 73%;
  }
}
</style>
